import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IOneMeetingRequestPayload extends ISagaCb {
    requestId: string
}

export interface IOneMeetingState {
    status: string
    data: any
    errors: any
}

const initialState: IOneMeetingState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const oneMeetingRequest = createSlice({
    name: 'meeting-requests/one-meeting',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IOneMeetingRequestPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const oneMeetingRequestActions = oneMeetingRequest.actions
export default oneMeetingRequest.reducer
